/**
 * Variant Data Processor
 * Processes raw variant data from the DOM and builds the prsp_variants global object.
 * This file should be loaded with defer to avoid blocking initial DOM rendering.
 */
(function() {
  // Skip if already processed
  if (typeof window.prsp_variants !== 'undefined') return;

  // Find the data element
  const dataEl = document.getElementById('variant-data-json');
  if (!dataEl) {
    console.warn('variant-data-processor: No #variant-data-json element found');
    return;
  }

  let rawData;
  try {
    rawData = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('variant-data-processor: Failed to parse variant data JSON', e);
    return;
  }

  const DEFAULT_METAFIELDS_ORDER_RAW = `attribute_flavour_1 @Flavour
LINEBREAK
tw_format @Format
LINEBREAK
tw_strength_grouping @Strength Group`;

  // Handle null/undefined values from Liquid's json filter
  const metafieldsOrderRaw = (rawData.metafieldsOrderRaw || '').trim()
    ? rawData.metafieldsOrderRaw
    : DEFAULT_METAFIELDS_ORDER_RAW;
  const metafieldsSpecificationOrderRaw = rawData.metafieldsSpecificationOrderRaw || '';
  const metafieldsComparisonOrderRaw = rawData.metafieldsComparisonOrderRaw || '';
  const variants = rawData.variants || {};

  const countLinebreaks = (metafieldsOrderRaw.match(/LINEBREAK/g) || []).length;

  function extractField(field) {
    const parts = field.trim().split('@');
    const key = parts[0].trim().toLowerCase().replace(/ /g, '_');
    const label = parts.length > 1 ? parts[1].trim() : '';
    return { key, label };
  }

  // Build grid, specificationList, and comparisonList for each variant
  Object.keys(variants).forEach(variantId => {
    const metafields = variants[variantId].metafields;

    // Build grid
    const grid = {};
    let row = 0, col = 0;
    metafieldsOrderRaw.trim().split('\n')
      .forEach(field => {
        if (row > 2) return; // max 3 rows

        if (field.trim() === 'LINEBREAK') {
          row++; col = 0;
          return;
        } else if (col > 3) {
          if (countLinebreaks > 1) return;
          row++; col = 0;
          if (!metafieldsOrderRaw.trim() || row > 2) return;
        }

        const { key, label } = extractField(field);

        if (metafields.hasOwnProperty(key)) {
          if (!grid[row]) grid[row] = {
            0: { value: "", key },
            1: { value: "", key },
            2: { value: "", key },
            3: { value: "", key }
          };

          grid[row][col] = {
            key: key,
            value: metafields[key].value,
            icon: metafields[key].icon,
            label: label
          };
          col++;
        }
      });
    variants[variantId].grid = grid;

    // Build specification list
    const specificationList = {};
    (metafieldsSpecificationOrderRaw.trim() ? metafieldsSpecificationOrderRaw.trim().split('\n') : [])
      .forEach(field => {
        const { key, label } = extractField(field);
        if (metafields.hasOwnProperty(key)) {
          specificationList[key] = {
            value: metafields[key].value,
            label: label
          };
        }
      });
    variants[variantId].specificationList = specificationList;

    // Build comparison list
    const comparisonList = {};
    (metafieldsComparisonOrderRaw.trim() ? metafieldsComparisonOrderRaw.trim().split('\n') : [])
      .forEach(field => {
        const { key, label } = extractField(field);
        if (metafields.hasOwnProperty(key)) {
          comparisonList[key] = {
            value: metafields[key].value,
            label: label
          };
        }
      });
    variants[variantId].comparisonList = comparisonList;
  });

  // Make globally accessible
  window.prsp_variants = variants;
  window.prsp_extractField = extractField;
  window.prsp_metafieldsOrderRaw = metafieldsOrderRaw;
  window.prsp_metafieldsSpecificationOrderRaw = metafieldsSpecificationOrderRaw;
  window.prsp_metafieldsComparisonOrderRaw = metafieldsComparisonOrderRaw;

  // Dispatch event to notify that variant data is ready
  window.dispatchEvent(new CustomEvent('prsp_variants_ready'));
})();
